export const META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID ?? "";

type FbqParams = Record<string, unknown>;

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

/**
 * Fire a Meta Pixel event; no-ops when the pixel is not configured or loaded.
 * Pass `eventId` for events also sent server-side via the Conversions API —
 * Meta deduplicates on (event_name, event_id) so the conversion counts once.
 */
export function trackMetaPixel(event: string, params?: FbqParams, eventId?: string): void {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return;
  if (params && eventId) window.fbq("track", event, params, { eventID: eventId });
  else if (params) window.fbq("track", event, params);
  else window.fbq("track", event);
}
